<template>
  <header
    class="p-4 md:p-6 flex gap-4 items-center"
    :class="{
      '!items-start': subtitle || $slots.subtitle,
    }"
  >
    <div
      v-if="icon"
      class="shrink-0 bg-primary-100 w-9 rounded aspect-square grid place-content-center text-primary-600"
    >
      <app-icon :icon="icon" />
    </div>
    <div class="grid gap-1 flex-auto">
      <dialog-title
        class="flex items-center justify-between gap-4 text-xl font-bold"
      >
        <div>
          <slot name="title">
            {{ title }}
          </slot>
        </div>
      </dialog-title>

      <dialog-description
        v-if="subtitle || $slots.subtitle"
        class="text-subtle text-sm"
      >
        <slot name="subtitle">
          {{ subtitle }}
        </slot>
      </dialog-description>
    </div>

    <app-dialog-close-button
      v-if="closeButton"
      class="self-start relative left-2"
      @click="$emit('close')"
    />
  </header>
</template>

<script lang="ts" setup>
import { DialogDescription, DialogTitle } from "@headlessui/vue";
import type { TranslateResult } from "vue-i18n";

defineProps<{
  title?: TranslateResult;
  subtitle?: TranslateResult;
  icon?: string;
  closeButton: boolean;
}>();

defineEmits(["close"]);
</script>
